export const experience = [

    {
        id: 1,
        org: "Freelance Agile Coach",
        period: "2008 - now",
        description:
            "Within this period I have done multiple roles, " +
            "but mainly Agile Coach roles. " +
            "the last 8 years mainly have been active " +
            "in transitions as Sr. coach."
    },

    {
        id: 2,
        org: "Financial Consulting",
        period: "2001 - 2008",
        description:
            "Roles like: Business Analyst, Process " +
            "Manager, Business Controller, Bookkeeper"
    },


]